import React, { useContext, useEffect, useState } from 'react';

import {
    Button,
    Typography
} from '@material-ui/core';

import Alert from '@material-ui/lab/Alert';

import { CustomerRequestContext } from '../CustomerRequestContext';
import { TabsContext  } from './TabsContext';
import { UserContext } from '../../../contexts';

import { RequestStatus, ApplicationRoles, SapTableNames } from '../../../../helpers';

import { makeStyles } from '@material-ui/styles';
import { DbType } from '../../../../helpers/Common';
const useStyles = makeStyles(() => ({
    root: {        
    }
}));

export const RequestAlerts = (props) => {
    const classes = useStyles(); 

    const { 
        userInfo,
        isUserInRole,
        isUserInRoles 
    } = useContext(UserContext);

    const {
        state
    } = useContext(CustomerRequestContext);

    const {
        hasAccountGroupDIST
    } = state;

    const {
        values
    } = useContext(TabsContext);

    let alerts = null;

    const getStatusAlerts = () => {
        alerts = [];

        switch (state.request.status){
            case RequestStatus.CreditRiskEvaluation:
                if (isUserInRole(ApplicationRoles.CreditRisk)){
                    let areErrors: boolean = false;

                    if (
                        values.ethicsCompliance.areRedFlags &&
                        !values.ethicsCompliance.isMitigated
                    ){
                        areErrors = true;
                        const message = 'New opening is about to be suspended. "Red flags" detected; E&C, Sales, and Credit Risk intervention required.';
                        const completeStatus = getCompleteStatusAlert(message, "ShowBusinessTab");
                        alerts.push(completeStatus);
                    }

                    if (
                        !values.riskEvaluation ||
                        values.riskEvaluation.creditControlAreaId === "" ||
                        //values.riskEvaluation.ratingId === "" ||
                        values.riskEvaluation.creditLimit === -1 ||
                        values.riskEvaluation.globalCreditLimit === -1 ||
                        values.riskEvaluation.creditLimitCurrencyId === "" ||
                        values.riskEvaluation.sheetInfoDocs === null ||
                        values.riskEvaluation.sheetInfoDocs === undefined ||
                        values.riskEvaluation.sheetInfoDocs.length === 0
                    ){
                        areErrors = true;
                        const message = "Request needs some additional information — please complete the risk evaluation form";
                        const completeStatus = getCompleteStatusAlert(message, "ShowBusinessTab");
                        alerts.push(completeStatus);
                    }

                    if (
                        values.dbType === DbType.S4 &&
                        (
                            !values.creditManagement ||
                            !values.creditManagement.segmentId ||
                            !values.creditManagement.creditTypes.some(x => x.endOfValidity)
                        )
                    ){
                        areErrors = true;
                        const message = "Request needs some additional information — please complete the credit management form";
                        const completeStatus = getCompleteStatusAlert(message, "ShowBusinessTab");
                        alerts.push(completeStatus);
                    }
                    
                    if (!areErrors)
                        alerts.push(getSendStatusAlert());
                }

                break;

            case RequestStatus.Logistic:
                if (isUserInRole(ApplicationRoles.LogisticDocumentation) && !values.isPerfumesCategory){
                    if (
                        values.logisticDocumentation === null ||
                        values.logisticDocumentation.transportationZoneId === "" ||
                        (
                            values.isInvoceAddressDifferentFromCustomer &&
                            values.invoiceAddresses.find((x) => x.transportationZoneId === "")
                        )
                    ){
                        const message = "Request needs some additional information — please complete the logistic documentation form";
                        const completeStatus = getCompleteStatusAlert(message, "ShowLogisticsTab");
                        alerts.push(completeStatus);
                    }
                    else if (!state.request.isLogisticDocumentationReady)
                        alerts.push(getSendStatusAlert());
                    else
                        alerts.push(getWaitStatusAlert());
                }

                if (isUserInRole(ApplicationRoles.LogisticCustomerService)){
                    if (
                        values.logisticCustomerService == null ||
                        //values.logisticCustomerService.customerTypeId === "" ||
                        values.logisticCustomerService.shippingConditionsId === "" ||
                        values.logisticCustomerService.forwardingAgent === "" ||
                        (
                            values.logisticDocumentation.transportationZoneId === "" &&
                            values.isPerfumesCategory
                        )
                    ){
                        const message = "Request needs some additional information — please complete the logistic customer service form";
                        const completeStatus = getCompleteStatusAlert(message, "ShowLogisticsTab");
                        alerts.push(completeStatus);
                    }
                    else if (!state.request.isLogisticCustomerServiceReady)
                        alerts.push(getSendStatusAlert());
                    else
                        alerts.push(getWaitStatusAlert());
                }
                
                if (isUserInRoles([ApplicationRoles.LogisticPlanning, ApplicationRoles.LogisticPlanningPerfumes])){
                    if (
                        values.logisticPlanning === null || //main object with the following keys: acceptBackOrders, cG4Id, deliveryPriorityId, requestedDeliveryDateId
                        values.logisticPlanning.deliveryPriorityId === "" ||
                        //values.logisticPlanning.requestedDeliveryDateId === "" || ??????????????
                        (
                            values.isPerfumesCategory &&
                            values.logisticPlanning.cG4Id === ""
                        )
                    ){
                        const message = "Request needs some additional information — please complete the distribution planning form";
                        const completeStatus = getCompleteStatusAlert(message, "ShowLogisticsTab");
                        alerts.push(completeStatus);
                    }
                    //the following "if" condition gets triggered only once, as soon as all the required data have been entered but the request hasn't been saved yet, so the boolean of completion is still set to false 
                    else if (!state.request.isLogisticPlanningReady)
                        alerts.push(getSendStatusAlert());
                    else
                        alerts.push(getWaitStatusAlert());
                }                

                if (isUserInRole(ApplicationRoles.AOFOpener) && values.ownerKey === userInfo.externalKey){
                    if (values.signedContract === null && values.isSignedContractAvailable === true){
                        const message = "Request needs some additional information — please complete the contract form";
                        const completeStatus = getCompleteStatusAlert(message, "ShowContractTab");
                        alerts.push(completeStatus);
                    }
                    else if (!state.request.isSignedContractReady)
                        alerts.push(getSendStatusAlert());
                    else
                        alerts.push(getWaitStatusAlert());
                }

                break; 
                        
            case RequestStatus.WaitingForContract:
                if (isUserInRole(ApplicationRoles.AOFOpener) && values.ownerKey === userInfo.externalKey) {
                    if (values.signedContract === null && values.isSignedContractAvailable === true){
                        const message = "Request needs some additional information — please complete the contract form";
                        const completeStatus = getCompleteStatusAlert(message, "ShowContractTab");
                        alerts.push(completeStatus);
                    }
                    else
                        alerts.push(getSendStatusAlert());
                }

                break;

            case RequestStatus.PricingUnit:
                if (isUserInRole(ApplicationRoles.PricingUnit)){
                    if (
                        !values.pricing ||
                        !values.pricing.pricingListId ||
                        !values.pricing.pricingGroupId
                    ){
                        const message = "Request needs some additional information — please complete the pricing form";
                        const completeStatus = getCompleteStatusAlert(message, "ShowPricingTab");
                        alerts.push(completeStatus);
                    }
                    else
                        alerts.push(getSendStatusAlert());
                }
                
                break;

            case RequestStatus.AccountReceivableApproval:
                if (isUserInRole(ApplicationRoles.AccountReceivable)){
                    let relevantChanges = false;

                    //values.isPerfumesCategory doesn't work. I have to use state.userBusinessCategories
                    if (
                        state.request.dataChanges &&
                        state.userBusinessCategories[0] &&
                        (
                            state.userBusinessCategories[0].value === "JWA" ?
                            state.request.dataChanges.some(x => !x.targetProperty.startsWith("AccountReceivable.") && x.targetProperty !== "LogisticPlanning.CG4") :
                            state.request.dataChanges.some(x => !x.targetProperty.startsWith("AccountReceivable."))
                        )
                    )
                        relevantChanges = true;

                    if (relevantChanges){
                        const message = "There are some changes in the request";
                        const warningStatus = getWarningStatusAlert(message, "Send the request to CRE");
                        alerts.push(warningStatus);
                        break;
                    }

                    if (
                        values.accountReceivable === null ||
                        values.accountReceivable.accountAssignmentGroupId === "" ||
                        values.accountReceivable.cashManagementGroupId === "" ||
                        values.accountReceivable.reconcilationAccountId === "" ||
                        values.accountReceivable.sortKeyId === "" ||
                        (
                            values.dbType === DbType.ECC &&
                            (
                                values.accountReceivable.taxCategories === null ||
                                values.accountReceivable.taxCategories.length === 0 ||
                                values.accountReceivable.taxCategories.some(x => x.taxClassificationName === "")
                            )
                        ) ||
                        (
                            !values.isPerfumesCategory &&
                            values.logisticPlanning.cG4Id === ""
                        )
                    ){
                        const message = "Request needs some additional information — please complete the account receivable form";
                        const completeStatus = getCompleteStatusAlert(message, "ShowAccRecTab");
                        alerts.push(completeStatus);
                    }
                    else
                        alerts.push(getSendStatusAlert());
                            
                    if (hasAccountGroupDIST && values.isCountryCanada){
                        const message = "Please remember to add the tax jurisdiction code in SAP";
                        const infoStatus = getInfoStatusAlert(message);
                        alerts.push(infoStatus);
                    }
                }
                
                break;     
                
            case RequestStatus.WaitingToBeAddedInSap:
            case RequestStatus.Approved:
                if (
                    isUserInRole(ApplicationRoles.AOFOpener) &&
                    values.ownerKey === userInfo.externalKey &&
                    !values.isSignedContractAvailable
                ){
                    const message = "Request needs some additional information — please complete the contract form";
                    const completeStatus = getCompleteStatusAlert(message, "ShowContractTab");
                    alerts.push(completeStatus);
                }

                break;

        
            default:
                break;
        }    
        
        return alerts;
    }

    const getInfoStatusAlert = (message) => {
        return (
            <Alert
                key={`alert-${alerts.length + 1}`}
                severity="info"
            >{message}</Alert>
        );
    }

    const getWaitStatusAlert = () => {
        return (
            <Alert
                key={`alert-${alerts.length + 1}`}
                severity="info"
            >Request has been sent — wait others till completion</Alert>
        );
    }

    const getSendStatusAlert = () => {
        return (
            <Alert
                key={`alert-${alerts.length + 1}`}
                severity="success"
            >Request has been compiled correctly — send it for approval</Alert>
        );        
    }

    const getWarningStatusAlert = (message, hint) => {
        return (
            <Alert
                key="warning"
                severity="warning"
            >{message} — {hint}</Alert>
        );
    }

    const getErrorStatusAlert = (message, hint) =>{
        return (
            <Alert
                key={`alert-${alerts.length + 1}`}
                severity="error"
            >{message} — {hint}</Alert>
        );
    }

    const getCompleteStatusAlert = (message, tabAction) => {
        return (
            <Alert
                key={`alert-${alerts.length + 1}`}
                severity="warning"
                action={
                    <Button
                        color="inherit"
                        size="small"
                        onClick={() => {
                            if (props.onCommand)
                                props.onCommand(tabAction)
                        }}
                    >COMPLETE</Button>
                }
            >{message}</Alert>
        );
    }

    return (
        <div className={classes.root}>
            {getStatusAlerts()}
        </div>
    );
}